import Reveal from "./Reveal";

export default function SectionHeader({ kicker, title, subtitle, align = "left", dark = false, id }) {
  const center = align === "center";
  return (
    <div id={id} className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
      {kicker && (
        <Reveal>
          <div className={`mb-5 flex items-center gap-3 ${center ? "justify-center" : ""}`}>
            <span className="h-px w-8 bg-accent" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.22em] text-accent">{kicker}</span>
          </div>
        </Reveal>
      )}
      <Reveal delay={0.05}>
        <h2 className={`font-heading text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-[3.4rem] ${dark ? "text-white" : "text-primary"}`}>
          {title}
        </h2>
      </Reveal>
      {subtitle && (
        <Reveal delay={0.1}>
          <p className={`mt-6 text-lg leading-relaxed ${dark ? "text-white/70" : "text-muted-foreground"}`}>{subtitle}</p>
        </Reveal>
      )}
    </div>
  );
}